import { produce } from "immer";
import * as uiActions from "./uiActions";

const initialState = {
  currentDate: parseFloat(Date.parse(new Date()) / 1000),
  view: "month",
  deleting: false,
  deleteErrorMessage: null,
  fetchErrorMessage: null,
  fetchParams: {},
  modal: {
    errorMessage: null,
    open: false,
    sending: false,
    mode: "create",
    values: {}
  },
  reminderModal: {}
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case uiActions.OPEN_MODAL: {
      draft.modal.open = true;
      draft.modal.mode = action.payload.mode;
      draft.modal.values = action.payload.values;
      break;
    }

    case uiActions.CLOSE_MODAL: {
      draft.modal.open = false;
      break;
    }

    case uiActions.SET_SENDING: {
      draft.modal.sending = action.payload;
      break;
    }

    case uiActions.SET_VIEW: {
      draft.view = action.payload;
      break;
    }

    case uiActions.SET_DELETING: {
      draft.deleting = action.payload;
      break;
    }

    case uiActions.SET_DELETE_ERROR_MESSAGE: {
      draft.deleteErrorMessage = action.payload;
      break;
    }

    case uiActions.SET_CURRENT_DATE: {
      const { currentDate, view } = action.payload;
      draft.currentDate = currentDate;
      if (view) {
        draft.view = view;
      }

      break;
    }

    case uiActions.REMIND_EVENT: {
      if (action.payload?.id) {
        let temp = { ...draft.reminderModal };
        temp[action.payload?.id] = action.payload;
        draft.reminderModal = { ...temp };
      }
      break;
    }

    case uiActions.CLEAN_REMINDERS: {
      draft.reminderModal = {};
      break;
    }

    case uiActions.SET_MODAL_ERROR_MESSAGE: {
      draft.modal.errorMessage = action.payload;
      break;
    }

    case uiActions.SET_FETCH_ERROR_MESSAGE: {
      draft.fetchErrorMessage = action.payload;
      break;
    }

    case uiActions.SET_FETCH_PARAMS: {
      draft.fetchParams = action.payload;
      break;
    }
    default:
      return draft;
  }
}, initialState);

export default reducer;
